import { render } from "./UserHome.component.vue?vue&type=template&id=ec522b2e"
import script from "./UserHome.component.vue?vue&type=script&lang=js"
export * from "./UserHome.component.vue?vue&type=script&lang=js"

import "./UserHome.component.vue?vue&type=style&index=0&id=ec522b2e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__